<template>
  <div class="box online_bg">
    <v-dialog/>
    <div class="wrap w1200">
      <!--右侧列表-->
      <div class="onsite_b task_jihua_detail">
        <!--顶部详情-->
        <div class="top_con">
          <p class="back_btn" style="cursor: pointer;">
            <a onclick="history.go(-1)">返回</a>
          </p>
          <dl>
            <dt>
              <img src="@/assets/images/zy_2.jpg" v-if="!form.coverUrl || form.coverUrl == ''" />
              <img :src="form.coverUrl" v-if="form.coverUrl && form.coverUrl !== ''">
            </dt>
            <dd>
              <h3 style="font-weight: 700;">{{form.title}}
                <span v-if="form.price && form.price > 0">￥<span style="color: #ff3633;
    font-size: 24px;">{{form.price}}</span>元</span>
                <span v-if="!form.price || form.price <= 0" style="display: inline-block; font-size: 14px; line-height: 14px; background: #ff3633; border-radius: 5px; color: white; padding: 5px;">免费</span>
              </h3>
              <!--p><a class="zan">139</a><a class="fav">539</a></p>
              <p><a class="zan_on">139</a><a class="fav_on">539</a></p-->
              <p class="time">{{ dateFormat(new Date(form.beginDate), 'yyyy-MM-dd hh:mm:ss') }} 至 {{ dateFormat(new Date(form.endDate), 'yyyy-MM-dd hh:mm:ss') }}</p>
              <a class="btn_go" @click="join(form)" v-if="!joined">加入计划</a>
              <a class="btn_go" v-if="joined">已加入</a>
            </dd>
          </dl>
        </div>
        <!--/顶部详情-->
        <!--tab-->
        <ul class="tabs" style="margin-left: 0; margin-right: 0;">
          <li class="tab_item" @click="panel = '1'"><a :class="{current: panel=='1'}">培训内容</a></li>
          <li class="tab_item" @click="panel = '2'"><a :class="{current: panel=='2'}">培训简介</a></li>
          <li class="tab_item" @click="panel = '4'"><a :class="{current: panel=='4'}">通过标准</a></li>
        </ul>
        <!--/tab-->
        <div class="tab_content">
          <!--培训内容-->
          <div v-if="panel == '1'" class="tab1_3 pxcon_list w1080">
            <dl v-for="item in planItemList" v-bind:key="item.id" style="position: relative;">
              <dt>
                <span>{{getPlanType(item.type)}}</span>
                <a>
                  <img src="@/assets/images/course_default.png" v-if="!item.faceUrl || item.faceUrl == ''" />
                  <img :src="item.faceUrl" v-if="item.faceUrl && item.faceUrl !== ''">
                </a>
              </dt>
              <dd style="width: 795px;">
                <h4>{{item.name}}<span v-if="item.isElective == '0'">选修</span><span v-if="item.isElective == '1'">必修</span></h4>
                <p class="px_text">学　　分：{{item.credit}}</p>
                <p v-html="item.introduction" class="px_sm"></p>
              </dd>
              <a style="cursor: pointer;" class="detail_btn" @click="to(path + '/courseDetail', item)" v-if="item.type=='00' && getProcess(item.id) == 100">课程已完成</a>
              <a style="cursor: pointer;" class="detail_btn" v-if="item.type=='01'  && getProcess(item.id) == 100">考试已完成</a>
              <a style="cursor: pointer;" class="detail_btn" v-if="item.type=='02'  && getProcess(item.id) == 100">问卷已完成</a>
              <a style="cursor: pointer;" class="detail_btn" @click="to(path + '/courseDetail', item)" v-if="item.type=='00' && Number(getProcess(item.id)) > 0 && Number(getProcess(item.id)) < 100">继续学习</a>
              <a style="cursor: pointer;" class="detail_btn" @click="to(path + '/examReady', item, '1')" v-if="item.type=='01'  && Number(getProcess(item.id)) > 0 && Number(getProcess(item.id)) < 100">继续考试</a>
              <a style="cursor: pointer;" class="detail_btn" @click="doQuestionnaire(item, '1')" v-if="item.type=='02'  && Number(getProcess(item.id)) > 0 && Number(getProcess(item.id)) < 100">继续回答</a>
              <a style="cursor: pointer;" class="detail_btn" @click="to(path + '/courseDetail', item)" v-if="item.type=='00' && getProcess(item.id) == 0">开始学习</a>
              <a style="cursor: pointer;" class="detail_btn" @click="to(path + '/examReady', item, '1')" v-if="item.type=='01'  && getProcess(item.id) ==  0">开始考试</a>
              <a style="cursor: pointer;" class="detail_btn" @click="doQuestionnaire(item, '1')" v-if="item.type=='02'  && getProcess(item.id) ==  0">回答问卷</a>
            </dl>
          </div>
          <!--/培训内容-->
          <!--培训简介-->
          <div v-if="panel == '2'" class="tab1_4 w1080 px_con">
            <p v-html="form.description"></p>
          </div>
          <!--/培训简介-->
          <div v-if="panel == '4'" class="tab1_8 tgbz_px w1080">
            <dl>
              <p v-if="findElem(form.passingCriteria, 'A') !== -1">
                <span>按学分:</span>
                <span>
                  {{standardTypeSubVal}} / {{totalCredits}}
                </span>
              </p>
              <p v-if="findElem(form.passingCriteria, 'B') !== -1">
                <span>按考试:</span>
                <span v-if="standardTypeSub2 == '1'">提交考试</span>
                <span v-if="standardTypeSub2 == '2'">通过考试</span>
              </p>
              <p v-if="findElem(form.passingCriteria, 'C') !== -1">
                <span>按问卷:</span>
                <span v-if="standardTypeSub3 == '1'">完成问卷</span>
              </p>
            </dl>
          </div>
        </div>
      </div>
      <!--/右侧列表-->
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
  import rangePermission from '@/utils/rangePermission'
  import config from '@/config'
  import api from '@/api'
  import utils from '@/utils'
  import difference from 'lodash.differenceby'
  import CertView from '@/page/byl/org/cert/display.vue'
  import { getCookie } from '@/store/cookies.js'
  export default {
    components: { CertView },
    props: ['path'],
    data () {
      return {
        panel: '1',
        orgType: '',
        form: {},
        planItemList: [],
        planUserItemMap: {},
        currentCs: [],
        currentEs: [],
        currentQs: [],
        certList: [],
        cert: {},
        totalCredits: 0,
        standardTypeSubVal: '',
        standardTypeSub2: '1',
        standardTypeSub3: '1',
        labelsMap: {
          'user_name': '刘海',
          'cert_code': '20080001',
          'cert_date': '2018-09-18',
          'user_idCardNo': '310xxxxxxxxxxx0987',
          'userplan_achievement': '35',
          'qrCodeUrl_1': '二维码串'
        },
        joined: false,
        examPaperInfo: {}
      }
    },
    created () {
      this.getModel(this.$route.params.id)
      this.isJoined() // 判断计划是否已经加入
      if (getCookie('org')) {
        this.orgType = getCookie('org').businessId || 'void'
      }
      /*rangePermission.checkScope({ // 防盗链
        itemId: this.$route.params.id,
        itemType: '05',
        permission: '02'
      }).then((r) => {
        if (!r.data) {
          let path = (process.env.NODE_ENV == 'development') ? 'http://localhost:8081' : config.domains[0] + ':' + config.webport
          window.location.href = path
        }
      })*/
    },
    mounted () {
      this.$on('data-prepared', (data) => {
        var cs = data.planItemList.filter((d) => {
          return d.type == '00'
        })
        var es = data.planItemList.filter((d) => {
          return d.type == '01'
        })
        var qs = data.planItemList.filter((d) => {
          return d.type == '02'
        })
        this.getCertListByIds([data.certId])
        var idsC = this.createIds(cs, 'itemId') // 课程Ids
        var idsE = this.createIds(es, 'itemId') // 考试Ids
        var idsQ = this.createIds(qs, 'itemId') // 问卷Ids
        // 要将planItemList分解成课程列表、试卷列表等等
        if (idsC.length > 0) { this.getCourseListByIds(idsC) }
        if (idsE.length > 0) { this.getExamListByIds(idsE) }
        if (idsQ.length > 0) { this.getQuizListByIds(idsQ) }
        var a = data.passingCriteria.split('|')
        var r = []
        for (let i = 0; i < a.length; i++) {
          let o = a[i]
          let n = o.split(':')
          if (n[2]) {
            this.standardTypeSubVal = n[2]
          }
          switch (o.split(':')[0]) {
            case "B": {
              this.standardTypeSub2 = o.split(':')[1]
              break
            }
            case "C": {
              this.standardTypeSub3 = o.split(':')[1]
              break
            }
          }
          r.push(o[0])
        }
        this.standardType = r
      });
    },
    watch: {
      'planItemList': {
        handler (newVal, oldVal) {
          if (newVal.length == 0) {
            this.totalCredits = 0
          } else {
            var result = 0;
            for (let i = 0; i < this.planItemList.length; i++) {
              let p = this.planItemList[i]
              if (p.credit) {
                result += Number(p.credit)
              }
            }
            this.totalCredits = result
          }
        },
        deep: true
      },
      'currentCs': {
        handler (val) {
          this.handleItems(val)
        },
        deep: true
      },
      'currentEs': {
        handler (val) {
          this.handleItems(val)
        },
        deep: true
      },
      'currentQs': {
        handler (val) {
          this.handleItems(val)
        },
        deep: true
      }
    },
    methods: {
      findElem: utils.findElem,
      dateFormat: utils.dateFormat,
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: o.title,
          text: o.text,
          buttons: [
            {
              title: '确认',
              default: true,
              handler: () => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }
            },
            {
              title: '取消'
            }
          ]
        })
      },
      isJoined () {
        if (getCookie('token')) {
          this.$api.post(this.$global.bylApiPath, '/studyItemPermissions/checkPermission', {
            itemId: this.$route.params.id,
            itemType: '05',
            permission: '02'
          }, r => {
            this.joined = r.data // true: 已购买过/已分配过; false: 未购买(未加入)
          })
        }
      },
      getPlanUserItemMap () {
        return new Promise((resolve, reject) => {
          api.post(config.bylApiPath, '/studyItemPermissions/myTasks', {itemType: '05'}, (r) => { // 需要拿到planUserItemMap
            if (r.data) {
              var lists = r.data;
              var idx = utils.findElem(lists, 'planId', this.$route.params.id)
              if (!lists[idx]) { lists[idx] = {} }
              this.getOne({id: lists[idx].id, planId: this.$route.params.id}).then((r) => {
                resolve(r)
              })
            } else {
              resolve(null)
            }
          })
        })
      },
      getProcess (itemId) { // 取得单项内容进度
        var p = 0;
        for (let i in this.planUserItemMap) {
          var o = this.planUserItemMap[i]
          if (o.itemId == itemId) {
            p = o.process
          }
        }
        return p;
      },
      getItemRecordIdBy (itemId) {
        var p;
        for (let i in this.planUserItemMap) {
          var o = this.planUserItemMap[i]
          if (o.itemId == itemId) {
            p = o.id
          }
        }
        return p;
      },
      getRecordId (itemId) { // 取得单项内容Id
        var p;
        for (let i in this.planUserItemMap) {
          var o = this.planUserItemMap[i]
          if (o.itemId == itemId) {
            p = o.id
          }
        }
        return p;
      },
      getPlanUserId () {
        var p;
        for (let i in this.planUserItemMap) {
          var o = this.planUserItemMap[i]
          p = o.planUserId
        }
        return p;
      },
      getPlanType (type) {
        switch (type) {
          case '00': {
            return '课程';
          }
          case '01': {
            return '考试';
          }
          case '02': {
            return '问卷';
          }
        }
      },
      createIds (arr, type) {
        var r = []
        for (var i = 0; i < arr.length; i++) {
          let s = arr[i]
          r.push({id: s[type], credit: s.credit, isElective: s.isElective, sort: s.sort})
        }
        return r
      },
      sequenceCheck (item) {
        var that = this
        var planUserId = this.getPlanUserId()
        return new Promise(function (resolve, reject) {
          that.$api.post(that.$global.bylApiPath, '/planUsers/checkLearningSequence/' + item.id, {planTitle: item.name, id: planUserId, planId: that.form.id}, r => {
            resolve(r.data)
          })
        })
      },
      planDateCheck () {
        let stime = this.dateFormat(new Date(this.form.beginDate), 'yyyy-MM-dd')
        let etime = this.dateFormat(new Date(this.form.endDate), 'yyyy-MM-dd')
        let rangeCheck = this.$utils.dateInRange(stime, etime)
        return rangeCheck
      },
      to (path, item, type) {
        var that = this
        var _go2itemPage = function () {
          if (type) {
            that.$router.push({
              path: path + '/' + item.id + '/' + type,
              query: {pid: that.getItemRecordIdBy(item.id)}
            })
          } else {
            that.$router.push({
              path: path + '/' + item.id
            })
          }
        }
        if (getCookie('token')) {
          let rangeCheck = this.planDateCheck()
          if (rangeCheck.inRange) {
            if (this.joined) {
              if (this.form.learningOrder == '0') { // 如需顺序学习
                this.sequenceCheck(item).then(function (isValid) {
                  if (isValid) {
                    _go2itemPage()
                  } else {
                    that.$toasted.show('该项学习任务需要在前一项学习任务完成后才能学习')
                  }
                });
              } else {
                _go2itemPage()
              }
            } else {
              this.$toasted.show('请先加入计划')
            }
          } else {
            this.$toasted.show('该计划' + rangeCheck.msg)
          }
        } else {
          this.$toasted.show('请先登录')
        }
      },
      getModel (id) {
        api.get(config.planApiPath, '/trainingplans/' + id, null, (r) => { // 正常
          this.form = r.data
          this.$emit('data-prepared', this.form)
        }, (err) => {
          console.log(err)
        })
      },
      getOne (o) { // 调用接口获取planItemUserMap
        if (o.id == 'undefined') { delete o.id }
        return new Promise(function (resolve, reject) {
          api.post(config.bylApiPath, '/planUsers/getOne', o, (r) => { // 正常
            resolve(r.data.planUserItemMap)
          })
        })
      },
      getCourseListByIds (idsArr) {
        var ids = utils.grabVal(idsArr, 'id')
        this.$api.get(this.$global.courseApiPath, '/course/batch', {ids: utils.arr2str(ids)}, r => {
          this.currentCs = r.data || []
          if (this.currentCs.length > 0) {
            for (var m = 0; m<this.currentCs.length; m++) { // 给每一个课程对象赋值“课程”
              var idx = utils.findElem(idsArr, 'id', this.currentCs[m].id)
              this.currentCs[m].credit = (idsArr[idx].credit) ? idsArr[idx].credit : '' // 学分赋值
              this.currentCs[m].isElective = idsArr[idx].isElective // 选/必修赋值
              this.currentCs[m].sort = idsArr[idx].sort
              this.currentCs[m].type = '00'
              this.currentCs[m].beginDate = ''
              this.currentCs[m].endDate = ''
            }
          }
        }, (err) => {
          console.log(err)
        })
      },
      getExamListByIds (idsArr) {
        var ids = utils.grabVal(idsArr, 'id')
        this.$api.post(this.$global.examApiPath, '/examPaper/search', {type: '1', idList: utils.arr2str(ids)}, r => {
          this.currentEs = r.data || []
          if (this.currentEs.length > 0) {
            for (var m = 0; m<this.currentEs.length; m++) { // 给每一个课程对象赋值“课程”
              var idx = utils.findElem(idsArr, 'id', this.currentEs[m].id)
              this.currentEs[m].name = this.currentEs[m].title
              this.currentEs[m].faceUrl = this.currentEs[m].faceUri
              this.currentEs[m].credit = (idsArr[idx].credit) ? idsArr[idx].credit : '' // 学分赋值
              this.currentEs[m].isElective = idsArr[idx].isElective // 选/必修赋值
              this.currentEs[m].sort = idsArr[idx].sort
              this.currentEs[m].type = '01'
              this.currentEs[m].beginDate = ''
              this.currentEs[m].endDate = ''
            }
          }
        }, (err) => {
          console.log(err)
        })
      },
      getQuizListByIds (idsArr) {
        var ids = utils.grabVal(idsArr, 'id')
        this.$api.post(this.$global.examApiPath, '/examPaper/search', {type: '2', idList: utils.arr2str(ids)}, r => {
          this.currentQs = r.data || []
          if (this.currentQs.length > 0) {
            for (var m = 0; m<this.currentQs.length; m++) { // 给每一个课程对象赋值“课程”
              var idx = utils.findElem(idsArr, 'id', this.currentQs[m].id)
              this.currentQs[m].name = this.currentQs[m].title
              this.currentQs[m].faceUrl = this.currentQs[m].faceUri
              this.currentQs[m].credit = (idsArr[idx].credit) ? idsArr[idx].credit : '' // 学分赋值
              this.currentQs[m].isElective = idsArr[idx].isElective // 选/必修赋值
              this.currentQs[m].sort = idsArr[idx].sort
              this.currentQs[m].type = '02'
              this.currentQs[m].beginDate = ''
              this.currentQs[m].endDate = ''
            }
          }
        }, (err) => {
          console.log(err)
        })
      },
      getCertListByIds (ids) {
        var that = this
        this.$api.post(this.$global.certApiPath, '/cert-templates/search', {includedIds: ids, isPublished: '1'}, r => {
          that.certList = r.data
          if (that.certList) {
            that.cert = that.certList[0]
          }
        }, (err) => {
          console.log(err)
        })
      },
      join (item) { // 加入计划
        if (getCookie('token')) {
          var bus = this
          let rangeCheck = this.planDateCheck()
          if (rangeCheck.inRange) {
            this.confirmBox({
              title: '加入计划',
              text: '确定加入计划吗？',
              yes: function () {
                if (item.price > 0) { // 价格大于0则需要购买
                  bus.goPay(item)
                } else { // 免费则直接加入计划
                  var o = {
                    planId: bus.form.id,
                    planTitle: bus.form.title
                  }
                  api.post(config.bylApiPath, '/planUsers/join', o, function (r) { // 正常
                    bus.$toasted.show(r.message)
                    bus.$modal.hide('dialog')
                    bus.joined = true
                  }, function (err) {
                    bus.$toasted.show(err)
                    bus.$modal.hide('dialog')
                    bus.joined = false
                  })
                }
              }
            })
          } else {
            this.$toasted.show('该计划' + rangeCheck.msg)
          }
        } else {
          this.$toasted.show('请先登录')
        }
      },
      goPay (item) {
        if (getCookie('token')) {
          if (!this.joined) {
            this.$api.post(this.$global.bylApiPath, '/planPurchaseHistorys/save', {planId: item.id, purchaseStatus: '0', money: item.price, purchaseTime: new Date()}, r => {
              if (r.data) {
                this.$router.push({path: '/continueEdu/planPay/'+ item.id + '/' + '5'+ '/' + r.data.id + '/' + this.orgType + '/' + encodeURIComponent(window.location.href) + '/' + r.data.sign})
              }
            })
          }
        } else {
          this.$toasted.show('请先登录')
        }
      },
      doQuestionnaire (item, type) {
        var that = this
        var _go2itemPage = function () {
          that.$api.post(that.$global.examApiPath, '/examPaper/searchByUser', {id: item.id}, r => { // 生成examId
            if (r.data) {
              that.examPaperInfo = r.data[0]
              that.startQuestionnaire(that.examPaperInfo, type, item.id)
            }
          })
        }
        if (getCookie('token')) {
          let rangeCheck = this.planDateCheck()
          if (rangeCheck.inRange) {
            if (this.joined) {
              if (this.form.learningOrder == '0') { // 如需顺序学习
                this.sequenceCheck(item).then(function (isValid) {
                  if (isValid) {
                    _go2itemPage()
                  } else {
                    that.$toasted.show('该项学习任务需要在前一项学习任务完成后才能学习')
                  }
                });
              } else {
                _go2itemPage()
              }
            } else {
              this.$toasted.show('请先加入计划')
            }
          } else {
            this.$toasted.show('该计划' + rangeCheck.msg)
          }
        } else {
          this.$toasted.show('请先登录')
        }
      },
      startQuestionnaire (examPaperInfo, type, itemId) {
        if (this.$TOKEN_VAL && this.$TOKEN_VAL!='') {
          let state = this.$utils.judgmentState(examPaperInfo.startDate, examPaperInfo.endDate)
          if (state=='0') {
            let that = this
            if (examPaperInfo.examId && examPaperInfo.examId!='' && examPaperInfo.remainTime>0) {
              this.$modal.show('dialog', {
                title: '提示',
                text: '该问卷存在未完成记录，是否继续？',
                buttons: [
                  {
                    title: '继续',
                    default: true,
                    handler: () => {
                      var itemRecordId = that.getItemRecordIdBy(itemId)
                      that.$modal.hide('dialog')
                      that.$api.post(that.$global.bylApiPath, '/planUsers/saveExamId', {examId: examPaperInfo.examId, id: itemRecordId}, r => {
                        that.$router.push({path: that.path + '/questionnaireStart/' + examPaperInfo.examId + '/' + type + '/' + examPaperInfo.id})
                      })
                    }
                  },
                  {
                    title: '重新开始',
                    handler: () => {
                      that.$api.post(that.$global.examApiPath, '/examExamScore/getExamId', {paperId: examPaperInfo.id}, r => {
                        if (r.data) {
                          var examId = r.data
                          var itemRecordId = that.getItemRecordIdBy(itemId)
                          that.$modal.hide('dialog')
                          that.$api.post(that.$global.bylApiPath, '/planUsers/saveExamId', {examId: r.data, id: itemRecordId}, r => {
                            that.$router.push({path: that.path + '/questionnaireStart/' + examId + '/' + type + '/' + examPaperInfo.id})
                          })
                        }
                      })
                    }
                  }
                ]
              })
            } else {
              that.$api.post(that.$global.examApiPath, '/examExamScore/getExamId', {paperId: examPaperInfo.id}, r => {
                if (r.data) {
                  var examId = r.data
                  var itemRecordId = that.getItemRecordIdBy(itemId)
                  that.$api.post(that.$global.bylApiPath, '/planUsers/saveExamId', {examId: r.data, id: itemRecordId}, r => {
                    that.$router.push({path: that.path + '/questionnaireStart/' + examId + '/' + type + '/' + examPaperInfo.id})
                  })
                }
              })
            }
          } else if (state=='1') {
            this.$toasted.show('该问卷已结束', {
              duration: 1000
            })
          } else if (state=='2') {
            this.$toasted.show('该问卷未开放', {
              duration: 1000
            })
          } else if (state=='-1') {
            this.$toasted.show('该问卷开始时间或结束时间有误', {
              duration: 1000
            })
          }
        } else {
          this.$toasted.show('请先登录！', {
            duration: 800
          })
        }
      },
      handleItems (val) { // 这个方法显示最终的planItemList
        if (getCookie('org')) {
          this.getPlanUserItemMap().then((r) => { // 显示单项内容的进度
            this.planUserItemMap = r
            this.planItemList = this.planItemList.concat(val)
            let resultArr
            if (this.form.learningOrder == '0') { // 有序
              resultArr = utils.sortByKey(this.sortTwoArr(this.form.planItemList, this.planItemList), 'sort')
            } else { // 无序
              resultArr = this.sortTwoArr(this.form.planItemList, this.planItemList)
            }
            // console.log(resultArr)
            if (this.planUserItemMap) {
              resultArr = this.sortFinished(resultArr) // 需要再次排序，将已完成的课程沉底
            }
            this.planItemList = resultArr
          })
        } else {
          this.planItemList = this.planItemList.concat(val)
          let resultArr
          if (this.form.learningOrder == '0') { // 有序
            resultArr = utils.sortByKey(this.sortTwoArr(this.form.planItemList, this.planItemList), 'sort')
          } else { // 无序
            resultArr = this.sortTwoArr(this.form.planItemList, this.planItemList)
          }
          this.planItemList = resultArr
        }
      },
      sortFinished (arr) {
        let finished = arr.filter((item, idx) => {
          let process = this.getProcess(item.id)
          return process == 100
        })
        var l = difference(arr, finished, 'id')  // 求差集
        return l.concat(finished)
      },
      sortTwoArr (arr1, arr2) {
        var resultArr = []
        for (let i = 0; i < arr1.length; i++) {
          let o = arr1[i]
          let businessId = o.itemId
          for (let j = 0; j < arr2.length; j++) {
            let o2 = arr2[j]
            if (o2.id == businessId) {
              resultArr.push(o2)
            }
          }
        }
        return resultArr
      }
    }
  }
</script>

<style scoped>
  .detail_btn {
    width: 116px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    color: #58acfa;
    display: block;
    border: 1px solid #58acfa;
    border-radius: 30px;
    position: absolute;
    top: 75px;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/page/modules/plan/detail.vue